import React from "react";

function Card({ number, title, subTitle }) {
  return (
    <div className="p-3 d-flex gap-0 flex-column border border-1 rounded-4 w-100 h-100">
      <div>
        <p className=" fs-3 m-0 p-0">{number}</p>
      </div>
      <div>
        <p className=" fs-3 fw-bold m-0 p-0">{title}</p>
      </div>
      <div>
        <p className=" fs-5 m-0 p-0">{subTitle}</p>
      </div>
    </div>
  );
}

export default Card;
